import { normalizeDashboards } from '../../../../utils'
import { ensureUniqueObjectIds } from '@edge/spark/utils'
import { getActiveDashboardId } from '../../../../Stores'
import {
    ClientUserDashboardsDocument as query,
    ClientUserDashboardsQuery,
    MutationResolvers,
    UpdateUserDashboardsDocument as mutation,
} from '../../../../generated/graphql'
import { createDialog } from '@edge/spark/feature-dialog'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { getActiveAuctionId } from '@edge/spark/io-roles'

const deleteDashboardCard: MutationResolvers<ApolloResolverContext>['deleteDashboardCard'] = async (
    _root,
    { cardId, dashId, userId },
    { cache, client },
) => {
    console.debug('io-dashboards deleteDashboardCard Deprecated, refactor (soon)')

    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    const auctionId = getActiveAuctionId()

    if (!auctionId) {
        throw new Error('deleteDashboardCard: Missing AuctionId')
    }

    if (userId && !dashId) {
        throw new Error('Custom userId without dashId')
    }

    const { data } = await client.query<ClientUserDashboardsQuery>({
        query,
        variables: { userId },
        fetchPolicy: 'network-only',
    })

    const savedDashboards = normalizeDashboards(data?.dashboards)
    const activeDashboardId = getActiveDashboardId()
    const dashboardIdToUpdate = dashId || activeDashboardId
    const dashboardToUpdateIndex = savedDashboards.findIndex((d) => d.id === dashboardIdToUpdate)
    const dashboardToUpdate = savedDashboards[dashboardToUpdateIndex]

    if (!dashboardToUpdate) {
        createDialog({
            action: 'OK',
            message: `Error: Dashboard with id:${dashboardIdToUpdate} not found`,
            timeout: 5000,
        })

        return null
    }

    const cardToDeleteIndex = dashboardToUpdate.cards.findIndex((card) => card.id === cardId)
    const updatedCards = [
        ...dashboardToUpdate.cards.slice(0, cardToDeleteIndex),
        ...dashboardToUpdate.cards.slice(cardToDeleteIndex + 1),
    ]
    const cleanedCards = ensureUniqueObjectIds(updatedCards)

    const updatedDashboard = { ...dashboardToUpdate, cards: cleanedCards }
    const updatedDashboards = [
        ...savedDashboards.slice(0, dashboardToUpdateIndex),
        updatedDashboard,
        ...savedDashboards.slice(dashboardToUpdateIndex + 1),
    ]

    const cleanedDashboards = ensureUniqueObjectIds(updatedDashboards)
    const stringifiedUpdatedDashboards = cleanedDashboards.map((d) => JSON.stringify(d))

    const admin = userId ? { auctionId, subjectUserId: userId } : undefined

    await client.mutate({
        mutation,
        variables: { admin, dashboards: stringifiedUpdatedDashboards },
        optimisticResponse: {
            updateUser: {
                __typename: 'UserMutationResponse',
                authenticationId: null,
                statusCode: 200,
                statusMessage: null,
            },
        },
        update: (store): void => {
            if (userId) {
                store.writeData({
                    data: {
                        [`dashboards({"userId":"${userId}"})`]: stringifiedUpdatedDashboards,
                        administrator: {
                            __typename: 'Administrator',
                            [`user({"input":{"admin":{"auctionId":"${auctionId}","subjectUserId":"${userId}"}}})`]: {
                                __typename: 'User',
                                dashboards: stringifiedUpdatedDashboards,
                            },
                        },
                    },
                })
            } else {
                store.writeData({
                    data: {
                        'dashboards({})': stringifiedUpdatedDashboards,
                        user: {
                            __typename: 'User',
                            dashboards: stringifiedUpdatedDashboards,
                        },
                    },
                })
            }
        },
    })

    return true
}

export default deleteDashboardCard
